import React, { useRef } from "react";
import { useNavigate, Routes, Route } from "react-router-dom";
import Nav from "./nav";
import Footer from "./footer";
import DeliveryInfo from "./deliveryInfo";
import About from "./about";
import Privacy from "./privacy";
import HomePage from "./homePage";
import PayInfo from "./payInfo";
import ProductItem from "./productItem";
import ProductChair from "./productChair";
import "animate.css";

import Table from "./img/1.webp";
import Table2 from "./img/2.webp";
import Table3 from "./img/3.webp";
import Table4 from "./img/4.webp";
import Table5 from "./img/5.webp";
import Table6 from "./img/6.webp";
import Table7 from "./img/7.webp";
import Table8 from "./img/8.webp";
import Table9 from "./img/9.webp";
import Table10 from "./img/10.webp";
import Table11 from "./img/11.webp";
import Table12 from "./img/12.webp";
import Table13 from "./img/13.webp";
import Table14 from "./img/14.webp";
import Table15 from "./img/15.webp";
import Table16 from "./img/16.webp";

import Chair from "./img/IMG_1726.webp";
import Chair2 from "./img/IMG_1725.webp";
import Chair3 from "./img/IMG_1723.webp";
import Chair4 from "./img/IMG_1721.webp";
import Chair5 from "./img/IMG_1716.webp";
import Chair6 from "./img/IMG_1715.webp";
import Chair7 from "./img/IMG_1714.webp";
import Chair8 from "./img/IMG_1711.webp";
import Chair9 from "./img/IMG_1710.webp";
import Chair10 from "./img/IMG_1709.webp";
import Chair11 from "./img/IMG_1708.webp";
import Chair12 from "./img/IMG_1706.webp";
import Chair13 from "./img/IMG_1705.webp";

function Page() {
  const navigate = useNavigate();
  const furnitureRef = useRef(null);
  const furnitureChairRef = useRef(null);

  const scrollToComponentChair = () => {
    if (window.location.pathname !== "/") {
      navigate("/");
    }
    setTimeout(() => {
      furnitureChairRef.current.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  const scrollToComponent = () => {
    if (window.location.pathname !== "/") {
      navigate("/");
    }
    setTimeout(() => {
      furnitureRef.current.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };
  const furniture = [
    {
      img: Table,
      title: "4 метр стол",
      subtext: "100% жангак",
      view: "table",
      price: 45_000,
      id: "f0",
    },
    {
      img: Table2,
      title: "4.5 метр стол",
      subtext: "100% жангак",
      view: "chair",
      price: 50_000,
      id: "f1",
    },
    {
      img: Table3,
      title: "5 метр стол",
      subtext: "100% жангак",
      view: "table",
      price: 55_000,
      id: "f2",
    },
    {
      img: Table4,
      title: "5.5 метр стол",
      subtext: "100% жангак",
      view: "table",
      price: 60000,
      id: "f3",
    },
    {
      img: Table9,
      title: "6 метр стол",
      subtext: "100% жангак",
      view: "chair",
      price: 65_000,
      id: "f4",
    },
    {
      img: Table6,
      title: "6.5 метр стол",
      subtext: "100% жангак",
      view: "table",
      price: 70_000,
      id: 5,
    },
  ];
  const chair = [
    {
      img: Chair,
      title: "Ажар",
      subtext: "100% жангак",
      view: "table",
      price: 5_300,
      id: "c0",
    },
    {
      img: Chair3,
      title: "Версаче",
      subtext: "100% жангак",
      view: "table",
      price: 5_300,
      id: "c2",
    },
    {
      img: Chair4,
      title: "Актилек",
      subtext: "100% жангак",
      view: "table",
      price: 5_200,
      id: "c3",
    },
    {
      img: Chair5,
      title: "Сон-Көл",
      subtext: "100% жангак",
      view: "table",
      price: 5_200,
      id: "c4",
    },
    {
      img: Chair7,
      title: "Ала-Тоо",
      subtext: "100% жангак",
      view: "table",
      price: 5_200,
      id: "c6",
    },
    {
      img: Chair8,
      title: "Акжолтой",
      subtext: "100% жангак",
      view: "table",
      price: 5_200,
      id: "c7",
    },
    {
      img: Chair9,
      title: "Ак-шумкар",
      subtext: "100% жангак",
      view: "table",
      price: 5_200,
      id: "c8",
    },
    {
      img: Chair10,
      title: "Ынтымак",
      subtext: "100% жангак",
      view: "table",
      price: 5_200,
      id: "c9",
    },
    {
      img: Chair11,
      title: "Байчечекей",
      subtext: "100% жангак",
      view: "table",
      price: 5_200,
      id: "c10",
    },
    {
      img: Chair12,
      title: "Кумушай",
      subtext: "100% жангак",
      view: "table",
      price: 6_200,
      id: "c11",
    },
  ];

  return (
    <div className="animate__animated animate__fadeIn">
      <Nav
        scrollToComponentChair={scrollToComponentChair}
        scrollToComponent={scrollToComponent}
      />
      <Routes>
        <Route path="/payInfo" element={<PayInfo />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/deliveryInfo" element={<DeliveryInfo />} />
        <Route path="/about" element={<About />} />
        <Route
          path="/"
          element={
            <HomePage
              furnitureChairRef={furnitureChairRef}
              furnitureRef={furnitureRef}
              furniture={furniture}
              chair={chair}
            />
          }
        />
        <Route path="/:id" element={<ProductItem furniture={furniture} />} />
        <Route path="/chair/:id" element={<ProductChair chair={chair} />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default Page;
